import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import {
  DependentEntityPicker,
  dependentEntityPickerSchema,
} from './DependentEntityPicker';

export const DependentEntityPickerExtension = FormFieldBlueprint.make({
  name: 'DependentEntityPicker',
  params: {
    field: async () =>
      createFormField({
        name: 'DependentEntityPicker',
        component: DependentEntityPicker,
        schema: dependentEntityPickerSchema,
      }),
  },
});
